'use client';

import { type FC } from 'react';
import { Tab } from '@yanolja-rnd/nol-design-system';

export interface TabAreaProps {
  tabLabels: string[];
  selectedIndex: number;
  onChangeTab: (index: number) => void;
}

export const TabArea: FC<TabAreaProps> = ({ tabLabels, selectedIndex, onChangeTab }) => {
  return (
    <>
      {/* 모바일 only */}
      <div className="mb-16 flex pc:hidden">
        <Tab
          shapeType="filled_capsule"
          slidesSpaceBetween={6}
          items={tabLabels}
          selectedIndex={selectedIndex}
          setSelectedIndex={onChangeTab}
        />
      </div>
      {/* PC only */}
      <div className="mb-16 hidden pc:flex">
        <Tab
          shapeType="filled_capsule"
          slidesSpaceBetween={8}
          items={tabLabels}
          selectedIndex={selectedIndex}
          setSelectedIndex={onChangeTab}
          slidesOffsetBefore={0}
          slidesOffsetAfter={0}
        />
      </div>
    </>
  );
};
